import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import CompanyInputForm from './CompanyInputForm.jsx'
import '../../assets/css/InputFormStyle.css';

const CompanyNewOrEditModal = (props) => {
  const {
    companyData,
    onUpdate,
  } = props;

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const isNewCompany = companyData == null;

  return (
    <div>
      <Button
        size="sm"
        color={isNewCompany ? "primary": "warning"}
        onClick={toggle}>
        <i className={`fa ${isNewCompany ? 'fa-plus' : 'fa-edit'}`} />
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="xl">
        <ModalHeader toggle={toggle}>
          {isNewCompany ? 'Nueva Empresa' : 'Editar Empresa'}
        </ModalHeader>
        <ModalBody>
          <CompanyInputForm
            onCancel={toggle}
            companyData={companyData}
            onUpdate={onUpdate}/>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CompanyNewOrEditModal;
